{
  "it": {
    "models": {
      "image": {
        "background": "Usare come sfondo?",
        "enabled": "Abilitato?",
        "global": "Globale?",
        "delete": "Elimina",
        "start": "Avvia",
        "cancel": "Annulla",
        "processing": "Elaborazione...",
        "error": "Errore",
        "name": "Nome",
        "size": "Dimensione file",
        "dropzone": "Trascina le immagini qui",
        "cancelUpload": "Annulla caricamento",
        "startUpload": "Avvia caricamento",
        "selectImages": "Aggiungi immagini...",
        "selectFolder": "Aggiungi una cartella..."
      }
    }
  }
}
